import { TableCell } from '@tiptap/extension-table'

export type { TableCellOptions } from '@tiptap/extension-table'
export { TableCell } from '@tiptap/extension-table'

export default TableCell
